module.exports = __webpack_public_path__ + "static/media/play-boss-1.32cbd95c.png";